/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_include_tag 'application_pack' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import "core-js/stable";
import "regenerator-runtime/runtime";

import Rails from "@rails/ujs";

Rails.start();

import { initSentry } from "sentry";
initSentry();

import { i18n } from "i18n/i18n";

// bootstrap
import { Alert, Button, Collapse, Dropdown, Modal, Popover, Tab, Tooltip } from "bootstrap";
const bootstrap = { Alert, Button, Collapse, Dropdown, Modal, Popover, Tab, Tooltip };
window.bootstrap = bootstrap;

import { Drawer } from "drawer";
import { Toast } from "toast";
import { Notification } from "notification";
import {
    checkTimeZone,
    checkIframe,
    initTooltips,
    ready,
    setHTMLExecuteScripts,
    replaceHTMLExecuteScripts,
} from "utilities.ts";
import { FaviconManager } from "favicon";
import { themeState } from "state/Theme";
import "components/saved_annotations/saved_annotation_list";
import "components/progress_bar";
import "components/theme_picker";
import { userState } from "state/Users";
import "components/series_icon.ts";
import "components/copy_container.ts";
import "components/datalist_input";

// Init drawer
ready.then(() => new Drawer());

ready.then(initTooltips);

// Use a global dodona object to prevent polluting the global na
const dodona = window.dodona || {};
dodona.dotManager = new FaviconManager(dodona.dotCount || []);
dodona.checkTimeZone = checkTimeZone;
dodona.Toast = Toast;
dodona.Notification = Notification;
dodona.initTooltips = initTooltips;
dodona.checkIframe = checkIframe;
dodona.setHTMLExecuteScripts = setHTMLExecuteScripts;
dodona.replaceHTMLExecuteScripts = replaceHTMLExecuteScripts;
dodona.setTheme = (theme) => (themeState.selectedTheme = theme);
dodona.setUserId = (userId) => (userState.id = userId);
dodona.ready = ready;
dodona.i18n = i18n;
window.dodona = dodona;
